import { render, staticRenderFns } from "./ReportCoolingChamber.vue?vue&type=template&id=772c74e9"
import script from "./ReportCoolingChamber.vue?vue&type=script&lang=js"
export * from "./ReportCoolingChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports